var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _path25, _path26, _path27, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 278,
    viewBox: "0 0 310 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 162L309 95",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.271 159.683C128.879 157.66 132.927 151.748 131.313 146.48C129.7 141.212 123.035 138.581 116.428 140.605C109.82 142.629 105.772 148.54 107.385 153.808C108.999 159.077 115.664 161.707 122.271 159.683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.17 110.313L131.448 115.434C125.729 117.186 122.508 123.228 124.254 128.93L128.12 141.553L107.217 147.955L102.876 133.781C97.9739 117.774 107.016 100.812 123.073 95.8945L141.978 90.1043C147.543 88.4 153.437 91.4868 155.182 97.0197C156.952 102.619 153.8 108.588 148.17 110.313Z",
    fill: "url(#paint0_linear_381_1440)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 217L309 150",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 138L215.13 224H258L177.87 138H138.5Z",
    fill: "#1782FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.191 138C142.601 138 141.228 141.062 142.951 142.996L214.235 222.996C214.805 223.635 215.62 224 216.475 224H251.104C253.726 224 255.087 220.873 253.299 218.955L178.76 138.955C178.192 138.346 177.397 138 176.565 138H145.191Z",
    fill: "url(#paint1_linear_381_1440)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.574 141.005C138.572 139.348 139.907 138 141.564 138C147.637 138 161.939 138 174.977 138C176.633 138 177.975 139.345 177.98 141.002C178.082 180.401 179.47 216 123.586 216C105.701 216 95.5718 216 90.9987 216C89.3419 216 88 214.657 88 213V188.46C88 186.803 89.3374 185.46 90.9943 185.46C95.2281 185.46 103.981 185.46 117.436 185.46C139.061 185.46 138.617 174.096 138.574 141.005Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.626 51.7882C165.626 51.7882 173.849 54.6698 173.849 65.6799C173.849 65.6799 173.691 67.4289 174.748 67.7204C177.412 68.4616 176.725 71.5598 174.806 71.9221C174.806 71.9221 174.161 88 160.59 88H146.5L147 80.5C147 80.5 134.689 71.539 140.269 65.1303C145.85 58.7216 165.626 51.7882 165.626 51.7882Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.957 89.8476C219.07 84.9612 211.951 84.1584 208.055 88.0545C204.158 91.9507 204.961 99.0703 209.848 103.957C214.734 108.843 221.854 109.646 225.75 105.75C229.646 101.854 228.843 94.7341 223.957 89.8476Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.855 156.461H137.851V104.983C137.851 93.9706 146.807 85.0424 157.855 85.0424C168.902 85.0424 177.858 93.9706 177.858 104.983V136.523C177.858 147.533 168.902 156.461 157.855 156.461Z",
    fill: "#5C94FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.916 76.4512C168.698 78.4605 171.227 79.7356 173.969 79.9275",
    stroke: "#1162FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.68 44.6186C154.68 44.6186 144.478 41.577 136.846 51C130.846 60 129.423 69.7539 138.346 79L146.466 87.8231L147.003 88.0358L148.5 77.5C148.576 76.9739 148.228 76.4711 147.694 76.3547C145.783 75.9264 143.677 74.3869 143.677 69.382C143.677 63.3669 149.236 63.1947 150.752 67.0076C150.899 67.3801 151.409 67.436 151.624 67.0961L155.252 61.365C155.252 61.365 167.722 61.5419 173.333 54.0929C178.943 46.6438 174.124 52.0025 168.99 47.3561C162.24 42.058 154.68 44.6186 154.68 44.6186Z",
    fill: "#0041E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M164.522 94.1715L177.064 105.919C181.536 110.106 190.087 112.643 194.288 108.185L202.973 98.9683C203.078 98.8574 217.577 110.933 217.577 110.933L216.275 112.314C199.872 129.719 172.422 130.573 154.962 114.221L150.003 109.577C145.762 105.605 145.525 98.9662 149.474 94.703C153.473 90.3897 160.229 90.1511 164.522 94.1715Z",
    fill: "#1162FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.466 92.2502L180.211 104.186C184.572 108.269 191.426 108.055 195.522 103.709L204.589 94.0877L220.522 109.01L210.34 119.813C198.841 132.015 179.598 132.613 167.358 121.151L152.948 107.654C148.707 103.681 148.47 97.0428 152.419 92.7797C156.416 88.4684 163.172 88.2298 167.466 92.2502Z",
    fill: "url(#paint2_linear_381_1440)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M232.818 25C231.832 28.3581 232.201 34.1988 239.115 37.2721",
    stroke: "white",
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 277L309 210",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M266.823 259.329L226.661 259.329C220.794 259.329 216.042 254.559 216.042 248.676L216.042 235.419C216.042 229.112 221.138 224 227.425 224L250.498 224C264.251 224 275.397 235.181 275.397 248.977L275.397 250.73C275.395 255.479 271.557 259.329 266.823 259.329Z",
    fill: "#4181FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_381_1440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 224,
    width: 60,
    height: 36
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.781 259.329L226.619 259.329C220.753 259.329 216 254.559 216 248.676L216 235.419C216 229.112 221.096 224 227.383 224L250.457 224C264.209 224 275.356 235.181 275.356 248.977L275.356 250.73C275.354 255.479 271.515 259.329 266.781 259.329Z",
    fill: "#1162FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_381_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.236 221.873L258.527 236.628C257.108 238.051 254.806 238.051 253.385 236.628C251.966 235.205 251.966 232.895 253.385 231.47L268.093 216.715C269.512 215.292 271.815 215.292 273.236 216.715C274.655 218.141 274.655 220.45 273.236 221.873Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.657 229.904L266.949 244.658C265.53 246.082 263.227 246.082 261.806 244.658C260.387 243.235 260.387 240.925 261.806 239.5L276.515 224.745C277.934 223.322 280.236 223.322 281.657 224.745C283.078 226.171 283.078 228.48 281.657 229.904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M168.43 67.8545H168.37C168.166 67.8545 168 67.6859 168 67.478V64.231C168 64.0231 168.166 63.8545 168.37 63.8545H168.43C168.634 63.8545 168.8 64.0231 168.8 64.231V67.478C168.8 67.6859 168.634 67.8545 168.43 67.8545Z",
    stroke: "#1162FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.244 59.9511C170.202 58.9612 168.57 58.5032 166.901 58.8792C165.232 59.2551 163.956 60.368 163.439 61.709",
    stroke: "#1162FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53 229.823V189.661C53 183.794 57.7699 179.042 63.6524 179.042H76.9102C83.2168 179.042 88.3289 184.138 88.3289 190.425V213.498C88.3289 227.251 77.1474 238.397 63.3522 238.397H61.5992C56.8503 238.395 53 234.557 53 229.823Z",
    fill: "#3B7EFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_381_1440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 179,
    width: 36,
    height: 60
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53 229.781V189.619C53 183.753 57.7699 179 63.6524 179H76.9102C83.2168 179 88.3289 184.096 88.3289 190.383V213.457C88.3289 227.209 77.1474 238.356 63.3522 238.356H61.5992C56.8503 238.354 53 234.515 53 229.781Z",
    fill: "#1162FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_381_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4556 236.236L75.701 221.527C74.2776 220.108 74.2776 217.806 75.701 216.385C77.1244 214.966 79.4337 214.966 80.8592 216.385L95.6139 231.093C97.0373 232.512 97.0373 234.815 95.6139 236.236C94.1884 237.655 91.879 237.655 90.4556 236.236Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4254 244.657L67.6707 229.949C66.2473 228.53 66.2473 226.227 67.6707 224.806C69.0941 223.387 71.4035 223.387 72.829 224.806L87.5836 239.515C89.007 240.934 89.007 243.236 87.5836 244.657C86.1581 246.078 83.8488 246.078 82.4254 244.657Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3423 45C30.5225 48.4026 31.1786 54.2181 38.2358 56.947",
    stroke: "white",
    strokeWidth: 5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M269.09 15.3297C270.107 11.9808 269.792 6.13691 262.907 3.00001",
    stroke: "white",
    strokeWidth: 5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.09 57.3297C267.107 53.9808 266.792 48.1369 259.907 45",
    stroke: "white",
    strokeWidth: 5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7756 100.616C35.6268 97.2213 35.0243 91.4001 27.9926 88.6063",
    stroke: "white",
    strokeWidth: 5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2148 73.01C70.066 69.6151 69.4635 63.7938 62.4318 61",
    stroke: "white",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_1440",
    x1: 123.057,
    y1: 95.8993,
    x2: 138.754,
    y2: 154.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1162FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_381_1440",
    x1: 153,
    y1: 146,
    x2: 247.5,
    y2: 206.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_381_1440",
    x1: 185.064,
    y1: 89.3839,
    x2: 185.064,
    y2: 129.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5891FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EBFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunMan);
export default __webpack_public_path__ + "static/media/RunMan.3a6d6f50.svg";
export { ForwardRef as ReactComponent };